import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';
import ConfigBusiness from '../config/ConfigBusiness.js';

function getOrInitApp() {
    var apps = getApps();
    return apps.length > 0 ? apps[0] : initializeApp(ConfigBusiness.get('firebase'));
}

var FirebaseMessagingListener = {
    init: function() {
        if (!('Notification' in window) || !('serviceWorker' in navigator)) {
            return;
        }

        if (!ConfigBusiness.get('firebase.apiKey')) {
            return;
        }

        try {
            var app = getOrInitApp();
            var messaging = getMessaging(app);

            onMessage(messaging, function(payload) {
                window.dispatchEvent(new CustomEvent('nueva-notificacion'));

                if (Notification.permission === 'granted' && navigator.serviceWorker) {
                    var title = payload.notification && payload.notification.title
                        ? payload.notification.title
                        : 'Nueva notificación';
                    var body = payload.notification && payload.notification.body
                        ? payload.notification.body
                        : '';
                    var url = payload.data && payload.data.url ? payload.data.url : '/';

                    navigator.serviceWorker.ready.then(function(registration) {
                        registration.showNotification(title, {
                            body: body,
                            icon: '/images/company/logo-login-app.png',
                            data: { url: url },
                        });
                    });
                }
            });
        } catch (e) {
            console.error('[FirebaseMessagingListener] Error al inicializar:', e);
        }
    },
};

export default FirebaseMessagingListener;
